import * as ambassadorWixRestaurantsCatalogsV3Discount from './restaurants-catalogs-v3-discount-discount.http.js';
import * as ambassadorWixRestaurantsCatalogsV3DiscountTypes from './restaurants-catalogs-v3-discount-discount.types.js';
import * as ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes from './restaurants-catalogs-v3-discount-discount.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDiscount(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string; discountId: string },
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.GetDiscountRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.GetDiscountRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.GetDiscountResponse,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.GetDiscountResponse
> {
  const payload = { catalogId: ':catalogId', discountId: ':discountId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Discount.getDiscount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/discounts/{discountId}',
    pathParams: { catalogId: 'catalogId', discountId: 'discountId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDiscount(): __PublicMethodMetaInfo<
  'PATCH',
  { catalogId: string; discountId: string },
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.UpdateDiscountRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.UpdateDiscountRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.UpdateDiscountResponse,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.UpdateDiscountResponse
> {
  const payload = {
    catalogId: ':catalogId',
    discount: { id: ':discountId' },
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Discount.updateDiscount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/catalogs/{catalogId}/discounts/{discount.id}',
    pathParams: { catalogId: 'catalogId', discountId: 'discountId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDiscount(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.CreateDiscountRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.CreateDiscountRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.CreateDiscountResponse,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.CreateDiscountResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Discount.createDiscount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/discounts',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDiscounts(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.ListDiscountsRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.ListDiscountsRequest,
  ambassadorWixRestaurantsCatalogsV3DiscountUniversalTypes.ListDiscountsResponse,
  ambassadorWixRestaurantsCatalogsV3DiscountTypes.ListDiscountsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Discount.listDiscounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/discounts',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Discount as DiscountOriginal,
  DiscountValueOneOf as DiscountValueOneOfOriginal,
  DiscountApplyToFilterOneOf as DiscountApplyToFilterOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Money as MoneyOriginal,
  SectionIds as SectionIdsOriginal,
  ItemIds as ItemIdsOriginal,
  DiscountCondition as DiscountConditionOriginal,
  FulfillmentType as FulfillmentTypeOriginal,
  FulfillmentTypeWithLiterals as FulfillmentTypeWithLiteralsOriginal,
  DiscountPlatform as DiscountPlatformOriginal,
  DiscountPlatformWithLiterals as DiscountPlatformWithLiteralsOriginal,
  Availability as AvailabilityOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Coupon as CouponOriginal,
  GetDiscountRequest as GetDiscountRequestOriginal,
  GetDiscountResponse as GetDiscountResponseOriginal,
  UpdateDiscountRequest as UpdateDiscountRequestOriginal,
  UpdateDiscountResponse as UpdateDiscountResponseOriginal,
  CreateDiscountRequest as CreateDiscountRequestOriginal,
  CreateDiscountResponse as CreateDiscountResponseOriginal,
  ListDiscountsRequest as ListDiscountsRequestOriginal,
  ListDiscountsResponse as ListDiscountsResponseOriginal,
  AddLoyaltyDiscount as AddLoyaltyDiscountOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './restaurants-catalogs-v3-discount-discount.types.js';
